module.exports = __webpack_public_path__ + "img/business.07f3aa21.jpg";